import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withTrackEvent(WrappedComponent) {
  // Need to broaden the type here since `getComponentName` doesn't take a generic argument for the component props
  const componentName = getComponentName(WrappedComponent);
  const TrackEventDecorator = props => {
    const trackEvent = useTrackEvent();
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
      trackEvent: trackEvent
    }, props));
  };
  TrackEventDecorator.displayName = `EventTrackingWithScreenContext(${componentName})`;

  /* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
  TrackEventDecorator.defaultProps = WrappedComponent.defaultProps;
  attachWrappedComponent(TrackEventDecorator, WrappedComponent);
  return TrackEventDecorator;
}